<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;" class=" fangyicontain">
            <div style="margin: 0 auto;">
                <div style="height: 7041px;background: url('http://p1.fishqc.net/FmgksO-rzkpzHNluGi9v20HsVSx4') center center no-repeat;background-size: auto 100%;">
                    <div class="mumcontain">
                        <div style="padding-bottom: 40px;">
                            <img class="verticalalign-middle" src="https://so.fishqc.com/activity/activityimg/mumsnet/title-left.png">
                            <span class="muntitle">16款母婴产品绿鱼优品榜单</span>
                            <img class="verticalalign-middle" src="https://so.fishqc.com/activity/activityimg/mumsnet/title-right.png">
                        </div>
                        <div class="munbox" v-for="item in productdata">
                            <div class="producttype">{{item.tap}}</div>
                            <div class="dec">{{item.dec}}</div>
                            <div class="dec-text">{{item.destext}}
                                <div class="tips">
                                    <img src="https://so.fishqc.com/activity/activityimg/mumsnet/rand-icon.png" mode="widthFix" style="width:24px;height:24px;vertical-align: middle;"></img>
                                    <div class="tipstext">小鱼大数据</div>
                                </div>
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img"  :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png" style="width:88px;" class="greenfish"></img>
                                        </div>
                                        <div class=" flex-one" style="text-align: left">
                                            <div class="brandcover">
                                                <div class="band" v-html="val.brand"></div>
                                                <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                            </div>
                                            <div class="title">{{val.title}}</div>
                                            <div class="detail-tips">{{val.tips}}</div>
                                            <div class="address">品牌所在地：{{val.address}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="techcontain">
                        <div>
                            <img class="verticalalign-middle" src="https://so.fishqc.com/activity/activityimg/mumsnet/title-left.png">
                            <span class="muntitle">小鱼亲测测评科技</span>
                            <img class="verticalalign-middle" src="https://so.fishqc.com/activity/activityimg/mumsnet/title-right.png">
                        </div>
                        <img src="http://p1.fishqc.net/FibVORaDs1FDd0mBYvd_l4uIyKtP" style="width: 100%;">
                        <div style="padding-top: 0px;text-align: center;">
                            <img src="https://so.fishqc.com/activity/activityimg/mumsnet/logo.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.mumcontain {
    width: 1000px;
    margin: 0 auto;
    display: block;
    text-align: center;
    padding-top: 1937px;

}

.muntitle {
    font-size: 32px;
    font-family: Songti SC;
    font-weight: 900;
    color: rgba(255, 255, 255, 1);
    line-height: 43px;
    text-shadow: 0px 3px 8px rgba(61, 186, 173, 0.9);
    padding: 0 20px;
    vertical-align: middle;
}

.verticalalign-middle {
    vertical-align: middle;
}

.munbox {
    width: 100%;
    background: rgba(242, 249, 248, 1);
    border-radius: 24px;
    padding: 0 32px 16px;
    margin-bottom: 60px;
}

.producttype {
    display: inline-block;
    width: 178px;
    height: 48px;
    line-height: 48px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    border-bottom-left-radius: 42px;
    border-bottom-right-radius: 42px;
    background: -webkit-linear-gradient(top, #3cc4b5, #2a9e91);
    background: -o-linear-gradient(top, #3cc4b5, #2a9e91);
    background: -moz-linear-gradient(top, #3cc4b5, #2a9e91);
    background: -ms-linear-gradient(top, #3cc4b5, #2a9e91);
    background: -webkit-gradient(linear, 0% 100%, from(#3cc4b5), to(#2a9e91));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #3cc4b5), color-stop(100%, #2a9e91));
    box-shadow: 0px 0px 8px #39b0a3;
}

.gradient {
    background: #000000;
    background: -moz-linear-gradient(top, #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #000000), color-stop(100%, #ffffff));
    background: -webkit-linear-gradient(top, #000000 0%, #ffffff 100%);
    background: -o-linear-gradient(top, #000000 0%, #ffffff 100%);
    background: -ms-linear-gradient(top, #000000 0%, #ffffff 100%);
    background: linear-gradient(to bottom, #000000 0%, #ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#000000', endColorstr='#ffffff', GradientType=0);
}

.dec {
    padding: 24px 0;
    box-sizing: border-box;
    color: #444a46;
    font-size: 24px;
    line-height: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(80, 79, 75, 1);
}

.dec-text {
    font-size: 18px;
    color: #494947;
    line-height: 30px;
    text-indent: 3px;
    text-align: left;
    padding: 20px 32px;
    background-color: #fff;
    border-radius: 20px;

    position: relative;
    margin-bottom: 36px;

}

.tips {
    width: 174px;
    height: 36px;
    line-height: 36px;
    background-color: #45ccbe;
    box-sizing: border-box;
    position: absolute;
    bottom: -20px;
    right: 0;
    border-bottom-right-radius: 20px;
    border-top-left-radius: 20px;
    text-align: center;

}

.tipstext {
    display: inline-block;
    font-size: 24px;
    color: #fff;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(225, 251, 248, 1);
}

.productdetailcontain {
    width: 456px;
    margin-right: 22px;
    display: inline-block;
    background-color: #fff;
    border-radius: 24px;
    height: 222px;
    vertical-align: top;
    margin-bottom: 32px;
    cursor: pointer;

}

.flex-container {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(2n) {
    margin-right: 0px;
}

.imgcontain {
    width: 200px;
    height: 100%;
    display: inline-block;
    text-align: center;
    position: relative;
}

.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.greenfish {
    position: absolute;
    right: 20px;
    bottom: 10px;
}

.class1 {
    width: 162px;
    height: 162px;
}

.class2 {
    width: 120px;
    height: 178px;
}

.class3 {
    width: 157px;
    height: 171px;
}

.class4 {
    width: 165px;
    height: 134px;
}

.class5 {
    width: 99px;
    height: 188px;
}

.class6 {
    width: 106px;
    height: 209px;
}

.class7 {
    width: 119px;
    height: 202px;
}

.class8 {
    width: 105px;
    height: 193px;
}

.class9 {
    width: 92px;
    height: 163px;
}

.class10 {
    width: 184px;
    height: 165px;
}

.class11 {
    width: 82px;
    height: 201px;
}

.class12 {
    width: 110px;
    height: 173px;
}

.class13 {
    width: 172px;
    height: 169px;
}

.class14 {
    width: 128px;
    height: 168px;
}

.class15 {
    width: 76px;
    height: 196px;
}

.class16 {
    width: 158px;
    height: 154px;
}

.flex-one {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.brandcover {
    padding: 38px 0 12px;
}

.band {

    font-size: 24px;
    line-height: 26px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(80, 79, 75, 1);
}

.title {
    font-size: 18px;
    line-height: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(80, 79, 75, 1);
    padding-bottom: 22px;
}

.detail-tips {
    padding: 0 12px;
    height: 30px;
    background: rgba(210, 242, 238, 1);
    border-radius: 12px 0px 12px 0px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(68, 204, 189, 1);
    line-height: 30px;
    display: inline-block;
    text-align: center;

}

.address {
    padding-top: 16px;
    font-size: 16px;
    line-height: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(121, 121, 121, 1);
}

.techcontain {
    padding-top: 60px;
    width: 1090px;
    margin: 0 auto;
    display: block;
    text-align: center;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata: [{
                    tap: '儿童零食',
                    dec: '跟着小鱼选高品质产品，让孩子吃得放心',
                    destext: '在小鱼测试过的儿童零食类产品中，仅有不超过30%的产品达到绿鱼评级，而大部分零食产品不达标的原因是类雌激素慢性毒超标。而类雌激素风险过高会导致癌症、性早熟、智商降低、糖尿病等病症。',
                    destext1: '',
                    product: [{
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/1.png',
                        class: 'class1',
                        brand: 'GOOD GOÛT',
                        brand1: '',
                        title: '榛子巧克力夹心米饼',
                        tips: '欧盟有机认证',
                        address: '法国',
                        type: 'food',
                        id: 'ns5hZxNaa1movHgBKKhplw'

                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/3.png',
                        class: 'class3',
                        brand: 'HEINZ 亨氏    ',
                        brand1: '',
                        title: '谷物磨牙棒（香橙/蔬菜/牛奶）',
                        tips: '均衡营养',
                        address: '美国',
                        type: 'food',
                        id: 'J0sLDQPzNwlOwbxwCn71Yw'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/4.png',
                        class: 'class4',
                        brand: 'SUNRYPE ',
                        brand1: '',
                        title: '果肉水果条',
                        tips: '健康美味',
                        address: '加拿大',
                        type: 'food',
                        id: 'Yxh79H1iSWh7qzqBiYeNoA'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/2.png',
                        class: 'class2',
                        brand: '旺旺 ',
                        brand1: '',
                        title: '旺仔小馒头（特浓牛奶味）',
                        tips: '怀旧小零食',
                        address: '中国',
                        type: 'food',
                        id: '98P4_e706mQ9-Py-TKy6DA'
                    }]
                },
                {
                    tap: '儿童防晒',
                    dec: '跟着小鱼选高品质产品，让宝宝用得放心',
                    destext: '在小鱼亲测数据库中，儿童防晒产品达到绿鱼评级的比例仅为35%，黄鱼和红鱼产品占比65%，多数产品急性毒测试不通过。急性毒风险偏高会导致皮肤刺激，过敏等不良反应。',
                    destext1: '',
                    product: [{
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/5.png',
                        class: 'class5',
                        brand: 'SEBAMED 施巴 ',
                        brand1: '',
                        title: '幼儿防晒润肤露 SPF 30',
                        tips: '温和亲肤',
                        address: '德国',
                        type: 'cosmetic',
                        id: 'QjokqfdjKDsbUW4BddsEZg'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/6.png',
                        class: 'class6',
                        brand: 'AVEENO 艾惟诺  ',
                        brand1: '',
                        title: '婴儿低敏温和防晒乳SPF 50',
                        tips: '低敏温和',
                        address: '美国',
                        type: 'cosmetic',
                        id: 'MdJsjEjf0VJtasB8oWKGeA'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/7.png',
                        class: 'class7',
                        brand: 'CALIFORNIA BABY <br>加州宝宝',
                        brand1: '加州宝宝 ',
                        title: '香茅防晒 SPF 30',
                        tips: '轻盈清透',
                        address: '美国',
                        type: 'cosmetic',
                        id: 'nIIGGgrk7nMeivEvi1R1Jw'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/8.png',
                        class: 'class8',
                        brand: 'BABYGANICS <br>甘尼克宝贝',
                        brand1: ' ',
                        title: '婴儿童防晒乳液 SPF50 +',
                        tips: '外防内养',
                        address: '美国',
                        type: 'cosmetic',
                        id: 'QeJ6NM8_uGLIpySVNIGyLg'
                    }]
                },
                {
                    tap: '孕妇保健品',
                    dec: '产前补充营养，跟着小鱼放心买',
                    destext: '准妈妈们在怀孕期间的营养补充也尤为重要，市面上琳琅满目的孕妇保健品该怎么选？目前小鱼数据库中，达到绿鱼品质卓越评级的孕妇保健品有70%以上呢，跟着小鱼放心买吧。',
                    destext1: '目前小鱼数据库中，达到绿鱼品质卓越评级的孕妇保健品有70%以上呢，跟着小鱼放心买吧。',
                    product: [{
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/9.png',
                        class: 'class9',
                        brand: 'BLACKMORES <br>澳佳宝',
                        brand1: ' ',
                        title: '孕妇黄金营养素',
                        tips: '人气口碑',
                        address: '澳大利亚',
                        type: 'food',
                        id: 'cW_N74C4g-mLLUkKwhq9vw'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/10.png',
                        class: 'class10',
                        brand: 'SILIAN <br>创盈金斯利安',
                        brand1: ' ',
                        title: '多维片',
                        tips: '性价比之王',
                        address: '中国',
                        type: 'food',
                        id: 'FAVUEkgXBX7Ik1FZd87Z2w'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/11.png',
                        class: 'class11',
                        brand: 'ELEVIT 爱乐维 ',
                        brand1: '',
                        title: '营养补充品',
                        tips: '多种营养',
                        address: '澳大利亚',
                        type: 'food',
                        id: 'RyGMP5V9N3Gi_UqkX81nWA'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/12.png',
                        class: 'class12',
                        brand: 'SWISSE 瑞思 ',
                        brand1: '',
                        title: '孕妇复合维生素叶酸片',
                        tips: '孕妈最爱',
                        address: '澳大利亚',
                        type: 'food',
                        id: '8Vfi_hBoUyujK2LZWxAKOw'
                    }]
                },
                {
                    tap: '护肤面膜',
                    dec: '爱宝宝也要爱自己，选对面膜悄悄变美',
                    destext: '当妈前是精致猪猪女孩，当妈后也要加强护肤。而面膜是护肤必备，怎么选当然很重要。在小鱼亲测的数据库中，60%以上的面膜达到绿鱼评级，跟着小鱼放心买吧。',
                    destext1: '在小鱼亲测的数据库中，60%以上的面膜达到绿鱼评级，跟着小鱼放心买吧。',
                    product: [{
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/13.png',
                        class: 'class13',
                        brand: 'FRESH 馥蕾诗',
                        brand1: '',
                        title: '玫瑰润泽保湿舒缓面膜',
                        tips: '滋润保湿',
                        address: '美国',
                        type: 'cosmetic',
                        id: 'Ie04onty4g8nEMATcW8FcA'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/14.png',
                        class: 'class14',
                        brand: 'MAMA GOODS <br>妈妈良品',
                        brand1: '',
                        title: '玻尿酸补水滋养面膜',
                        tips: '性价比之王',
                        address: '中国',
                        type: 'cosmetic',
                        id: 'gHu8ofyRAax2mdMIWIdUYg'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/15.png',
                        class: 'class15',
                        brand: 'EAU THERMALE<br>AVENE 雅漾',
                        brand1: '',
                        title: '修红舒润面膜',
                        tips: '温和滋润',
                        address: '法国',
                        type: 'cosmetic',
                        id: 'Bft2kV6kQ9TY6ooulbCPeg'
                    }, {
                        img: 'https://so.fishqc.com/activity/activityimg/mumsnet/16.png',
                        class: 'class16',
                        brand: 'ESTEE LAUDER<br>雅诗兰黛',
                        brand1: '',
                        title: '密集修护肌透面膜',
                        tips: '人气之王',
                        address: '美国',
                        type: 'cosmetic',
                        id: 'U-3oBx1OIzGS44_sPvWcFg'
                    }]
                }

            ],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>